module.exports = __webpack_public_path__ + "img/Mb_video.16ff13a2.jpg";